import * as React from 'react';
import {keyframes} from 'styled-components';

import {CTA, styled, useTheme} from '@volkswagen-onehub/components-core';
import {ChevronLeft, ChevronRight} from '@volkswagen-onehub/icons-core';
import {Direction} from '../helpers';

// NOTE: this might come later from some sizing token
const OUT_OF_SCREEN_POSITION = 64;

const anim = keyframes`
from {
    left: -${OUT_OF_SCREEN_POSITION}px;
    right: -${OUT_OF_SCREEN_POSITION}px;

} to {
    left: 0;
    right: 0;
}
`;

const StyledArrowsWrapper = styled.div`
    position: absolute;
    z-index: 1;
    left: 0;
    right: 0;
    bottom: 0;

    left: -${OUT_OF_SCREEN_POSITION}px;
    right: -${OUT_OF_SCREEN_POSITION}px;

    display: flex;
    justify-content: space-between;
    pointer-events: none;

    animation-name: ${anim};
    animation-duration: 0.5s;
    animation-iteration-count: 1;
    animation-delay: 0.25s;
    animation-fill-mode: forwards;

    button {
        pointer-events: auto;
    }
`;

interface FullscreenGalleryArrowsProps {
    triggerPrevious(): void;
    triggerNext(): void;
    prevAriaLabel?: string;
    nextAriaLabel?: string;
}

export const FullscreenGalleryArrows: React.FunctionComponent<
    FullscreenGalleryArrowsProps
> = props => {
    const {triggerPrevious, triggerNext, prevAriaLabel, nextAriaLabel} = props;
    const {direction} = useTheme();

    return (
        <StyledArrowsWrapper>
            <CTA
                tag="button"
                onClick={() => triggerPrevious()}
                aria-label={prevAriaLabel}
                emphasis="secondary"
                icon={
                    direction === Direction.RTL ? (
                        <ChevronRight aria-hidden variant="small" />
                    ) : (
                        <ChevronLeft aria-hidden variant="small" />
                    )
                }
                size="small"
            />
            <CTA
                tag="button"
                onClick={() => triggerNext()}
                aria-label={nextAriaLabel}
                emphasis="secondary"
                icon={
                    direction === Direction.RTL ? (
                        <ChevronLeft aria-hidden variant="small" />
                    ) : (
                        <ChevronRight aria-hidden variant="small" />
                    )
                }
                size="small"
            />
        </StyledArrowsWrapper>
    );
};
